import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Icon from "@material-ui/core/Icon";
import {uid} from "react-uid";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";

const useStyles = makeStyles(() => ({}));
const BottomMenu = (props) => {
    const {
        component = {},
        doActions
    } = props;
    const {styles: sourceStyles, children = [], properties} = component;
    const styles = sourceStyles ? sourceStyles[0] : {};
    const classes = useStyles();
    const [activeItem, setActiveItem] = useState(0);
    return (
        <div style={{...styles}}>
            <BottomNavigation
                onChange={(e, v) => setActiveItem(v)}
                showLabels={properties.showLabels}
                value={activeItem}
            >
                {children.map((item, index) => (
                    <NavigationItem
                        key={uid(item)}
                        item={item}
                        index={index}
                        doActions={doActions}
                    />
                ))}
            </BottomNavigation>
        </div>
    )
};

export default JsonScreenHoc(BottomMenu);

BottomMenu.propTypes = {
    component: PropTypes.object,
};


const NavigationItem = (props) => {
    const {
        item: {properties = {}, events = []} = {},
        doActions
    } = props;

    const [actions, setActions] = useState([]);
    useEffect(() => {
        if (events.length) {
            const onClickIndex = events.findIndex(f => f.event === 'onClick');
            if (onClickIndex !== -1) setActions(events[onClickIndex].actions)
        }
    }, []);

    function onClickNavItem() {
        if (!actions.length) return;
        doActions(actions)
    }

    return (
        <BottomNavigationAction
            selected={props.selected}
            showLabel={props.showLabel}
            onChange={props.onChange}
            value={props.value}
            index={props.index}
            onClick={onClickNavItem}
            label={properties.label}
            icon={<Icon>{properties.icon}</Icon>}
        />
    )
};

NavigationItem.propTypes = {
    item: PropTypes.object,
    doActions: PropTypes.func
};